// Deadlines are calendar dates stored at UTC midnight, not local instants.
export const deadlineDate = (value) => value ? String(value).slice(0, 10) : "";
export const formatDeadline = (value) => {
  const date = deadlineDate(value);
  if (!date) return "";
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

const dueTime = (task) => {
  let time;
  if (task.deadline) {
    // Deadlines represent a calendar day in the viewer's time zone.
    const [year, month, day] = deadlineDate(task.deadline).split("-").map(Number);
    time = new Date(year, month - 1, day).getTime();
  } else if (task.eventEnd) {
    time = new Date(task.eventEnd).getTime();
  }
  return Number.isFinite(time) ? time : null;
};

export const sortTasks = (tasks, mode = "manual", reversed = false) => [...tasks].sort((a, b) => {
  const direction = reversed ? -1 : 1;
  const manual = (Number(a.position) || 0) - (Number(b.position) || 0) || a.id - b.id;
  if (mode === "title") return direction * (a.title.localeCompare(b.title, undefined, { sensitivity: "base" }) || manual);
  if (mode === "deadline") {
    const first = dueTime(a);
    const second = dueTime(b);
    if (first === null && second !== null) return 1;
    if (first !== null && second === null) return -1;
    return direction * (first - second || manual);
  }
  return direction * manual;
});
